export function getMediaRailCtaKey(
  contentType: string | null | undefined,
): 'FOCAL_WATCH' | 'FOCAL_LISTEN' | 'FOCAL_READ' | 'FOCAL_VIEW' {
  switch (contentType) {
    case 'video':
      return 'FOCAL_WATCH';
    case 'article':
      return 'FOCAL_READ';
    case 'collection':
    case 'image':
    case 'quiz':
    case 'game':
      return 'FOCAL_VIEW';
    default:
      return 'FOCAL_LISTEN';
  }
}
